export default "__VITE_ASSET__4b8e6896__"